import authRoutes from './auth';
import dashboardRoutes from './dashboard';
import adminRoutes from './admin';

export default [
    ...authRoutes,
    ...dashboardRoutes,
    ...adminRoutes,
];
